// extracted by mini-css-extract-plugin
module.exports = {"root":"TypesInfoModal_root__1jP8W","row":"TypesInfoModal_row__3ZK5O","title":"TypesInfoModal_title__1hdCJ"};